import React, { useState } from 'react';
import "./input.css";

export default function Input({ onSubmit }) {
  const [input, setInput] = useState("");
  const buttonsData = [
    { title: 'Materialeingang / Materialausgang mit Kontrolle und Weitergabe an die Produktion incl. Auffragsnummer', color: '#005B96' },
    { title: 'Baugruppe montieren', color: 'orange' },
    { title: 'Maschine einrichten', color: 'teal' },
    { title: 'CNC Fräsen', color: '#1FD655' },
    { title: 'Konventionell Fräsen', color: '#649200' },
    { title: 'CNC Drehen', color: '#a2afb0' },
    { title: 'Konventionell Drehen', color: 'grey' }, // This button will be removed
    { title: 'Schweißen', color: '#95CBE2' },
    { title: 'Sägen', color: '#844204' },
    { title: 'Konservieren / Lackieren', color: '#680000' },
    { title: 'Verpacken / Versenden', color: '#E9D700' },
    { title: 'Transport innerhalb der Firma', color: '#1E64AF' },
    { title: 'Qualitätskontrolle', color: 'blue' },
    { title: 'Sonstiges', color: '#373737' },
    { title: 'AnGABS Formulare zu re übergeben', color: 'pink' },
    { title: 'Stoßen', color: '#557882' },
    { title: 'Normalisieren / Härten', color: '#60CDB8' },
  ];

  const handleSubmit = (title) => {
    const clickedButton = buttonsData.find(button => button.title === title);
    console.log("clickedButton",clickedButton)
    if (clickedButton) {
      onSubmit(clickedButton);
    }
  };

  return (
    <div className='container'>
      {/* <input
        type="text"
        className='input'
        value={input}
        onChange={e => setInput(e.target.value)}
      /> */}
      <div className="buttons-container">
        {buttonsData.map((button, index) => (
          <button
            key={index}
            style={{ backgroundColor: button.color }}
            onClick={() => handleSubmit(button.title)}
          >
            {button.title}
          </button>
        ))}
      </div>
    </div>
  );
}
